import { logError } from "@/shared/utils/datadog-logger";
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
    queryCache: new QueryCache({
        onError: (error, query) => {
            // Log all query errors to Datadog
            logError("React Query error", error, {
                errorType: "query",
                queryKey: query.queryKey,
            });
        },
    }),
    mutationCache: new MutationCache({
        onError: (error, _variables, _context, mutation) => {
            // Log all mutation errors to Datadog
            logError("React Query mutation error", error, {
                errorType: "mutation",
                mutationKey: mutation.options.mutationKey,
            });
        },
    }),
    defaultOptions: {
        queries: {
            // staleTime: 0 (the default) ensures data is always refetched on:
            // - component mount
            // - window focus (tab switch)
            // - network reconnect

            // Most queries require fresh data and shouldn't rely solely on websockets. Override per query if needed.
            staleTime: 0,
        },
    },
});
